import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "../ui/card";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Button } from "../ui/button";

const AttendanceFiltersCard = ({ filters, setFilters, employees, setDefaultDates }) => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardContent className="pt-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="space-y-2">
          <Label>{t("attComp.simpleFilters.employee")}</Label>
          <Select
            value={filters.employee_id}
            onValueChange={(value) => setFilters({ ...filters, employee_id: value })}
          >
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t("attComp.allEmployees")}</SelectItem>
              {employees.map((emp) => (
                <SelectItem key={emp.id} value={emp.id.toString()}>
                  {emp.last_name} {emp.first_name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>{t("attComp.simpleFilters.startDate")}</Label>
          <Input
            type="date"
            value={filters.start_date}
            onChange={(e) => setFilters({ ...filters, start_date: e.target.value })}
          />
        </div>

        <div className="space-y-2">
          <Label>{t("attComp.simpleFilters.endDate")}</Label>
          <Input
            type="date"
            value={filters.end_date}
            onChange={(e) => setFilters({ ...filters, end_date: e.target.value })}
          />
        </div>

        <div className="flex items-end">
          <Button variant="outline" onClick={setDefaultDates} className="w-full">
            {t("attComp.simpleFilters.last7days")}
          </Button>
        </div>
      </div>
    </CardContent>
  </Card>
  );
};

export default AttendanceFiltersCard;
